import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { HandGesture } from './hand-gesture.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements AfterViewInit {
  @ViewChild('video') video: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas') canvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('home') homeLink: ElementRef<HTMLAnchorElement>;
  @ViewChild('about') aboutLink: ElementRef<HTMLAnchorElement>;
  @ViewChild('img') imgLink: ElementRef<HTMLAnchorElement>;
  @ViewChild('vid') vidLink: ElementRef<HTMLAnchorElement>;
  @ViewChild('mnist') mnistLink: ElementRef<HTMLAnchorElement>;
  @ViewChild('face') faceLink: ElementRef<HTMLAnchorElement>;
  
  //isChecked = true;
  public isChecked: boolean = true;
  videoOnOff: string = 'on';
  

  toggleChanges($event: MatSlideToggleChange) {
    this.isChecked = $event.checked;
        
    if (!this.isChecked) {
      this.videoOnOff = "off";
    }
    if(this.isChecked){
      this.videoOnOff = "on";
      window.location.reload();
    }
  }

  opened$ = this._recognizer.swipe$.pipe(
    filter((value) => value === 'left' || value === 'right'),
    map((value) => value === 'right')
  );

  selection$ = this._recognizer.gesture$.pipe(
      filter((value) => value === 'one' || value === 'two' || value === 'three'),
      map((value) => (      
       value === 'one' ? 'home' : value === 'two' ? 'about' : value === 'three' ? 'img' : ''
       )
      )
    );

  constructor(private _recognizer: HandGesture, private _router: Router) {
    this._recognizer.gesture$
      .pipe(
        filter((value) => value === 'ok'),
        withLatestFrom(this.selection$)
      )
      .subscribe(([_, page]) => this._router.navigateByUrl(page));
  }

  get stream(): MediaStream {
    return this._recognizer.stream;
  }

  ngAfterViewInit(): void {
    this._recognizer.initialize(
      this.canvas.nativeElement,
      this.video.nativeElement
    );
  }
}
